module.exports = __webpack_public_path__ + "static/media/border-left.4af7ddd6.svg";